import Swiper from 'swiper';
import BaseFeature from '../../foundation/base/base';

class InfoSlider extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.viewport = this.el.querySelector('[data-ref="info-slider__viewport"]');
		this.next = this.el.querySelector('[data-ref="info-slider__next"]');
		this.prev = this.el.querySelector('[data-ref="info-slider__prev"]');
		this.pagination = this.el.querySelector('[data-ref="info-slider__pagination"]');
		this.infoItems = this.el.querySelectorAll('[data-ref="info-slider__item"]');

		this.config = {
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			navigation: {
				nextEl: this.next,
				prevEl: this.prev,
			},
			a11y: {
				prevSlideMessage: 'Næste',
				nextSlideMessage: 'Forrige',
			},
			pagination: {
				el: this.infoItems.length > 1 ? this.pagination : false,
			},
			grabCursor: true,
			slidesPerView: 1,
			loop: this.infoItems.length > 1,
		};

		this.init();
	}

	init() {
		this.swiper = new Swiper(this.viewport, this.config);
		if (this.infoItems.length <= 1) {
			this.next.classList.add('o-info-slider__button--none');
			this.prev.classList.add('o-info-slider__button--none');
		}
	}
}

export default InfoSlider;
